const axios = require('axios')

const API_KEY = '2e9e8c8367ebc15ff2dcd575bb889cc5'

const getCourierFee = (pickupBranch, destinationSuburb, destinationCode, weightInKg) => {
  const params = {
    api_key: API_KEY,
    WeightInKg: weightInKg
  }
  const url = `https://sa.api.fastway.org/v5/psc/lookup/${pickupBranch}/${destinationSuburb}/${destinationCode}`
  return axios.get(url, { params })
}

module.exports = { getCourierFee }
